:host {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: block;
  position: absolute;
  transform: translateZ(0);
  contain: strict;
  cursor: pointer;
  opacity: 0.01;
  touch-action: none;
  z-index: 2;
}

:host(.backdrop-hide) {
  background: transparent;
}

:host(.backdrop-no-tappable) {
  cursor: auto;
}

:host {
  background-color: var(--ion-backdrop-color, #000);
}